import styles from './Philosophy.module.scss'
import { useRef } from 'react'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

interface Props {
  list: {
    title: string
    text: string
  }[]
}

const Philosophy: React.FC<Props> = ({ list }) => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  return (
    <section
      className={`${styles.wrapper} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <h2 className={styles.sectionTitle}>私たちの考え方</h2>
      <div className={styles.philosophy}>
        <figure className={styles.philosophy__img}>
          <img src="/img/services/uxui_philosophy.webp" alt="私たちの考え方" />
        </figure>
        <ul className={styles.philosophy__list}>
          {list.map((item, index) => (
            <li key={index} className={`${styles.philosophy__list__item}`}>
              <h3 className={styles.philosophy__list__item__title}>{item.title}</h3>
              <p className={styles.philosophy__list__item__text}>{item.text}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}

export default Philosophy
